import { Navigate } from 'react-router-dom';
import { useUserLoginInfoContext } from 'authentication/authentication-outer/UserLoginInfo/UserLoginInfoContext';
import Cache from 'common/cache/lib/utils/Cache';
import { useLogoutUser } from 'helpers/logout';

const RootRedirect = () => {
  const userLoginInfo = useUserLoginInfoContext();
  const logout = useLogoutUser();

  const isAuthenticated =
    (Object.keys(userLoginInfo)?.length > 0 &&
      userLoginInfo?.signInUserSession?.accessToken?.jwtToken) ||
    (Cache.get('accessToken') && Cache.get('accessToken') !== 'undefined');

  const isTokenExpired =
    Date.now() / 1000 >
    userLoginInfo?.signInUserSession?.accessToken?.payload?.exp;

  if (isTokenExpired) {
    logout();
  }

  return <Navigate to={isAuthenticated ? '/dashboard' : '/login'} replace />;
};

export default RootRedirect;
